<template>
  <div class="echarts-wrap">
    <div class="echart" :id="id"></div>
    <div class="no-data" v-if="!hasMapJson"></div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
    name:'mapChart',
    data(){
         return {
           hasMapJson: true,
            chart:'',
            provinces : {
                '上海市': 'shanghai',
                '河北省': 'hebei',
                '山西省': 'shanxi',
                '内蒙古自治区': 'neimenggu',
                '辽宁省': 'liaoning',
                '吉林省': 'jilin',
                '黑龙江省': 'heilongjiang',
                '江苏省': 'jiangsu',
                '浙江省': 'zhejiang',
                '安徽省': 'anhui',
                '福建省': 'fujian',
                '江西省': 'jiangxi',
                '山东省': 'shandong',
                '河南省': 'henan',
                '湖北省': 'hubei',
                '湖南省': 'hunan',
                '广东省': 'guangdong',
                '广西壮族自治区': 'guangxi',
                '海南省': 'hainan',
                '四川省': 'sichuan',
                '贵州省': 'guizhou',
                '云南省': 'yunnan',
                '西藏自治区': 'xizang',
                '陕西省': 'shanxi1',
                '甘肃省': 'gansu',
                '青海省': 'qinghai',
                '宁夏回族自治区': 'ningxia',
                '新疆维吾尔自治区': 'xinjiang',
                '北京市': 'beijing',
                '天津市': 'tianjin',
                '重庆市': 'chongqing',
                '香港特别行政区': 'xianggang',
                '澳门特别行政区': 'aomen',
                '台湾省': 'taiwan'
            },
            cityMap:{}
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: {
            type: Array | Object
        },
        optionName:{
            type: String
        },
        areaName: {
            type: String,
            default:'全国'
        },
        isShow: {
            type: Boolean,
            default:true
        },
        isShowTit: {
            type: Boolean,
            default:false
        },
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.$axios.get(that.$mapOssMapUrl + '/citymaps.json').then((r) => {
                that.cityMap = r.data.cityMap;
                that.init();
            })
        })
    },
    watch: {
        dataArray () {
            this.init();
        }
    },
    methods: {
        mapOption(name){
            let data = this.dataArray,avag = parseInt(data[0].value/4);
            let len = parseInt(data[0].value/4).toString().length-1;
            if(len!=0){
                avag = parseInt((data[0].value/4)/Math.pow(10,len))*Math.pow(10,len);
            }
            let option = {
                title: {
                    show:this.isShowTit,
                    text: '区域热度分布图',
                    left: '0',
                    top: 10,
                    textStyle: {
                        fontSize: 14 ,
                        color: '#333'
                    }
                },
                tooltip: {
                    show: this.isShow,
                    formatter: function(params) {
                        let newParams='';
                        if(params.data){
                            newParams = params.name + '' + params.data['value']
                        }
                        return newParams;
                    },
                },
                visualMap: {
                    show:this.isShow,
                    type: 'piecewise',
                    showLabel: !0,
                    text: ['高', '低'],
                    left: '-5',
                    // itemWidth: 20,
                    precision:0,
                    itemHeight:10,
                    itemGap:5,
                    min: 0,
                    max: data[0].value,
                    inRange: {
                        color: ['#fefbf5',"#f79c9c", '#e42e2e', '#c80f0f', '#a40e0e']
                    },
                    pieces: [
                        {min: avag*4}, // 不指定 max，表示 max 为无限大（Infinity）。
                        {min: avag*3, max: avag*4},
                        {min: avag*2, max: avag*3},
                        {min: avag, max: avag*2},
                        {min: 0, max: avag,},
                    ],
                    show: !0,
                    //splitNumber: 0,
                    calculable: true,
                },
                geo: {
                    map: name,
                    zoom:1.1,
                    type: 'map',
                    mapType: name,
                    label: {
                      normal: {
                        show: false,

                      },
                      emphasis: {
                        show: true
                      }
                    },
                    itemStyle: {
                      normal: {
                        areaColor: '#fff',
                        borderWidth: 1,
                        borderColor: '#aaa',

                      },
                      emphasis: {
                        show: true,
                        areaColor: '#f5a741',
                      }
                    },
                    regions: [
                      { // 隐藏南海诸岛
                        name: '南海诸岛',
                        itemStyle: {
                          // 隐藏地图
                          normal: {
                            opacity: 0 // 为 0 时不绘制该图形
                          }
                        },
                        label: {
                          show: false // 隐藏文字
                        }
                      }
                    ]
                },
                series: [{
                    name: 'MAP',
                    zoom:1.1,
                    type: 'map',
                    mapType: name,
                    //selectedMode: 'false',//是否允许选中多个区域
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#fff',
                            borderWidth: 1,
                            borderColor: '#aaa',

                        },
                        emphasis: {
                            show: true,
                            areaColor: '#f5a741',
                        }
                    },
                    geoIndex: 0,
                    data: data
                }]
            };
            return option;
        },
        loadMap(mapCode, name,isCall) {
            let that = this;
            that.$axios.get(mapCode).then(res=>{
                that.$echarts.registerMap(name, res.data);
                that.chart.setOption(that.mapOption(name));
            }).catch(error =>{
            //   console.log(error);
            });
        },
        init(){
            let that = this, timeFn = null;
            that.$echarts.init(document.getElementById(that.id)).dispose();
            that.chart = that.$echarts.init(document.getElementById(that.id));
             this.hasMapJson = true

          // console.log(that.areaName)
            if(that.areaName=="全国"){
                that.loadMap('https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_briefdoc_new/static/map/json/china_new.json', 'china');
            }else{
                if(that.areaName in that.provinces){
                    that.loadMap(that.$mapOssMapUrl + '/provinces/'+that.provinces[that.areaName]+'.json', that.areaName);
                }else if(that.areaName in that.cityMap){
                    that.loadMap(that.$mapOssMapUrl + '/city/'+that.cityMap[that.areaName]+'.json', that.areaName);
                }else{
                  this.hasMapJson = false
                  return
                }
            }

            that.chart.on('click', function(params) {
                if(!params.name) return false
                clearTimeout(timeFn);
                //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
                timeFn = setTimeout(function() {
                    let name = params.name; //地区name
                    let mapCode = that.provinces[name]; //地区的json数据
                    let mapCode1 = that.cityMap[name]; //地区的json数据
                    console.log(name, mapCode, mapCode1)
                    if (!mapCode) {
                        //alert('无此区域地图显示');
                        if(!mapCode1){
                            that.$parent.fatherMethod(name,3);
                            return
                        }
                        that.loadMap('/static/json/city/'+that.cityMap[name]+'.json', name);
                        that.$parent.fatherMethod(name,2);
                        return;
                    }
                    // that.loadMap(mapCode, name);
                    that.$parent.fatherMethod(name,1);
                }, 250);
            });
            // // 绑定双击事件，返回全国地图
            // that.chart.on('dblclick', function(params) {
            //     //当双击事件发生时，清除单击事件，仅响应双击事件
            //     clearTimeout(timeFn);
            //     //返回全国地图
            //     that.$parent.fatherMethod("全国",that.id);
            //     // that.loadMap('/echarts/china', 'china');
            // });
           window.addEventListener("resize",function(){
                that.chart.resize();
            });
        },
    },
}
</script>
<style lang="" scoped>
.echarts-wrap {width:100%;height:100%;position: relative;}
.no-data{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0 auto;
  background-position: center center;
}
    .echart{width:100%;height:100%}
</style>



// WEBPACK FOOTER //
// src/components/echart/hotMapChart.vue